// Application entrypoint
// This file can be used for global JavaScript/TypeScript initialization

console.log('Vite ⚡️ Rails')

// Import global styles for consistent typography
import '../styles/global.css'
